import { render } from "./SupplierRevenueBreakdown.vue?vue&type=template&id=24f6a47d"
import script from "./SupplierRevenueBreakdown.vue?vue&type=script&lang=js"
export * from "./SupplierRevenueBreakdown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__